import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { api } from '@/lib/api';

/**
 * Hook para verificar se o usuário atualmente logado tem o tipo de usuário "MEDICO".
 */
export function useIsMedico() {
  const { user, isAuthenticated } = useAuth();

  // Verifica na API se o ID do tipo de usuário atual possui o código "MEDICO"
  const { data: isMedico = false, isLoading } = useQuery({
    queryKey: ['isMedico', user?.id_tipo_usuario],
    queryFn: async () => {
      if (!user?.id_tipo_usuario) return false;
      
      try {
        const response = await api.get('/api/tipo-usuario');
        const tipos = response?.result || [];

        // Verifica se o id_tipo_usuario bate com um tipo com código "MEDICO"
        const isUserMedico = tipos.some(
          (tipo: any) => tipo.id === user.id_tipo_usuario && tipo.codigo === 'MEDICO'
        );

        return isUserMedico;
      } catch (error) {
        console.error('Erro ao verificar tipo de usuário:', error);
        return false;
      }
    },
    enabled: !!user?.id_tipo_usuario && isAuthenticated,
    staleTime: 60 * 60 * 1000, // 1 hora de cache, já que raramente muda enquanto logado
  });

  return { isMedico, isLoading };
}
